/* eslint-disable react/prop-types */
import React from 'react'

import { HeaderHeight, HeaderMenu, Space, Margin,Logo } from './styles'
import { Container } from '@mui/material'
import { HiChevronLeft } from 'react-icons/hi'
import Search from '../Search'
import Cart from '../Cart'
import { useNavigate } from 'react-router-dom'
import Scroll from '../ScrollToTop'
import { useOpen } from '../../hooks/Open'

function Header (props) {
  const navigate = useNavigate()
  const { closeAllMenu } = useOpen()


  const redirectPage = () => {
    closeAllMenu();
    navigate('/loja')
  }

  return (

        <Container>
            <HeaderHeight>
                <HeaderMenu>
                    <Margin>
                        <HiChevronLeft onClick={() => navigate(-1)} />
                    </Margin>
                    <Logo onClick={() => redirectPage()} alt="Logo" />
                    <Space>
                        <Cart />
                        <Search onClick={props.searchNoMenu} />
                    </Space>
                </HeaderMenu>
            </HeaderHeight>
            <Scroll />
        </Container>

  )
}

export default Header
